import accountCreation from './account_creation.json';
import agentVerification from './agent_verification.json';
import hearAboutOpendoor from './hear_about_opendoor.json';
import homebuilder from './homebuilder.json';
import lisingAgentInfo from './listing_agent_info.json';
import lwc_intro from './lwc_intro.json';
import optional from './optional.json';
import postValuations from './post_valuations.json';
import relationship from './relationship.json';
import valuations from './valuations.json';

export const subflows = [
  accountCreation,
  agentVerification,
  lwc_intro,
  hearAboutOpendoor,
  homebuilder,
  lisingAgentInfo,
  optional,
  postValuations,
  relationship,
  valuations,
];
